import { createInstance } from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { findCDNBaseUrlFromUrl } from '@zooplus/commons-lang';
import { CURRENT_SITE_REALM, CURRENT_SITE_LOCALE } from '../utils/site-utils.js';
import { sendErrorToSentry } from './sentry-service.js';

const TRANSLATION_FILE_RELATIVE_PATH = `customer-account/customer-data-frontend/locales/${CURRENT_SITE_REALM}`;
const initializeI18n = async () => {
    const DEFAULT_LOCALE = 'zu';
    const i18nInstance = createInstance();
    const cdnUrl = findCDNBaseUrlFromUrl();
    await i18nInstance
        .use(HttpApi)
        .use(initReactI18next)
        .init({
        compatibilityJSON: 'v3',
        partialBundledLanguages: true,
        backend: {
            loadPath: (lng, ns) => `${cdnUrl}/media/${ns}/${lng[0]}.json`,
        },
        lng: CURRENT_SITE_LOCALE,
        load: 'currentOnly',
        preload: [DEFAULT_LOCALE],
        ns: [],
        fallbackLng: DEFAULT_LOCALE,
        defaultNS: TRANSLATION_FILE_RELATIVE_PATH,
        debug: false,
    });
    i18nInstance.on('failedLoading', (lng, ns, message) => {
        sendErrorToSentry(new Error(`Could not load ${lng} in ns ${ns}, error message: ${message}`));
    });
    return i18nInstance;
};

export { TRANSLATION_FILE_RELATIVE_PATH, initializeI18n };
//# sourceMappingURL=i18n-language-service.js.map
